import React, { Suspense } from 'react';
// import { Route,BrowserRouter,Redirect,useLocation } from 'react-router-dom';
import { Nav, Navbar, NavDropdown, Form, FormControl, Button, NavItem } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export const HeaderDynamic = (props) => {

  // const { i18n } = useTranslation();
  // const changeLanguage = lng => {
  //   i18n.changeLanguage(lng);
  // };
var menu = props.menu;
var projectName = props.projectName;
var logo = props.logo; // 512x512
// var NavLinkList = Object.keys(menu).map(function(key) {
//   console.log("--------- ",menu[key]);
//   return <Nav.Link href={key}>{menu[key]}</Nav.Link>
// });
return (
      <>
        {
          logo != null && logo != ""
          ?
            <>
            <Navbar bg="white" expand="md" fixed="top" variant="light" >
              <div className="container">
              {/* <Navbar.Brand href="#home">{projectName} </Navbar.Brand> */}
              <Navbar.Brand href="/"><img src={logo} style={{maxHeight:"50px"}} className="" alt="logo" /></Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="mr-auto">
                  {
                    menu.map((route, index) => {
                      // return <Nav.Link href={"#"+route.path}>{route.name}</Nav.Link>;
                      if(route.menuLink && route.menuLink != "" && route.menuName && route.menuName != '')
                      return <Nav.Link href={"#"+route.menuLink}>{route.menuName}</Nav.Link>;
                    })
                  }
                  {/* <Nav.Link href="#home">Home</Nav.Link> */}
                  </Nav>
              </Navbar.Collapse>
              </div>
            </Navbar>
            <div style={{marginTop:"80px"}}></div>
            </>
          : ""
        }
        
      </>
    );

}
